import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Carousel } from "react-responsive-carousel";

import * as UserActions from "../../../../redux/actions/user";
import * as SearchActions from "../../../../redux/actions/search";
import { createBoxes } from "../../../../helpers";
import { TrendingContainer } from "./styles";

function Trending(props) {
  let {
    auth,
    addToCart,
    publisher,
    removeFromCart,
    removeVideoFromList,
    toggleModal,
    user,
  } = props;

  let addFavorite = toggleModal;
  let removeFavorite = removeVideoFromList;
  const { sectionTitle, viralVideos } = publisher.homepage;

  const [mobile, setMobile] = useState(window.innerWidth <= 991);

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth <= 991);

    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, []);

  const onCreateBoxes = () =>
    createBoxes(
      {
        videos: viralVideos && viralVideos.map((it) => it),
        user: user,
        auth: auth,
        methods: {
          addFavorite,
          removeFavorite,
          addToCart,
          removeFromCart,
        },
      },
      "home"
    );

  return (
    <TrendingContainer className="trending__wrapper">
      <h2>
        {sectionTitle.viralTitle
          ? sectionTitle.viralTitle
          : "Viral Videos of the Week"}
      </h2>
      <div className="row">
        <div className="col-12">
          <div className="tab-content">
            <div className="trending-container">
              <div className="trendingItem">
                {mobile ? (
                  <Carousel
                    showThumbs={false}
                    showArrows={false}
                    showStatus={false}
                  >
                    {onCreateBoxes()}
                  </Carousel>
                ) : (
                  <div className="flex">{onCreateBoxes()}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearer" />
    </TrendingContainer>
  );
}

Trending.propTypes = {
  user: PropTypes.shape().isRequired,
  search: PropTypes.shape().isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  removeVideoFromList: PropTypes.func.isRequired,
  getTrendingVideos: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  search: state.search,
});

const actionCreators = {
  ...UserActions,
  ...SearchActions,
};

export default connect(mapStateToProps, actionCreators)(Trending);
